import { UserRole } from '@packages/store/types';

export const getUserRole = (currentUser: any): UserRole => {
    const { licenses, roles } = currentUser;
    const licenseTypesIds = licenses?.map(
        (license: any) => license.license_type_id
    );
    const roleCodes = roles?.map((role: any) => role.code);
    if (currentUser.teacher_is_active) {
        return UserRole.TEACHER;
    }
    if (licenseTypesIds?.length > 0) {
        if (licenseTypesIds.includes(5)) {
            return UserRole.HR;
        }
        if (licenseTypesIds.includes(3)) {
            return UserRole.DISTRIBUTOR;
        }
        if (licenseTypesIds.includes(8)) {
            return UserRole.COORDINATOR;
        }
    } else {
        if (roleCodes?.includes('distributor')) {
            return UserRole.DISTRIBUTOR;
        }
        if (roleCodes?.includes('coordinator')) {
            return UserRole.COORDINATOR;
        }
        if (roleCodes?.includes('payroll')) {
            return UserRole.PAYROLL_ACCOUNTANT;
        }
    }
    return UserRole.STUDENT;
};

// Убрать из этого файла
const isAnyRouteMatch = (routes: string[], pathname: string) => {
    return routes.some((route) => pathname.startsWith(route));
};

export const userHelpers = {
    getUserRole,
    isAnyRouteMatch,
};
